import { CognitoErrorMap } from "data/cognitoErrorList.enum";

// Helper function to get user-friendly error message and log to console
export const getCognitoErrorMessage = (error: any): string => {
  if (!error || typeof error !== "object") return CognitoErrorMap.Default;

  const errorCode = error.code || error.name;
  let rawMessage = error.message || "";

  // 1. Handle Lambda-based error first
  if (
    errorCode === "UserLambdaValidationException" &&
    typeof rawMessage === "string" &&
    rawMessage.includes("with error ")
  ) {
    const customMessage = rawMessage.split("with error ")[1]?.trim();
    return customMessage || CognitoErrorMap.Default;
  }

  // 2. Use CognitoErrorMap for known errors
  if (errorCode && CognitoErrorMap[errorCode]) {
    return CognitoErrorMap[errorCode];
  }

  // 3. Fallback to default or raw message
  return rawMessage || CognitoErrorMap.Default;
};

export function extractErrorMessage(error: any): string {
  console.log("Raw Error:", error);
  let errorList: any =
    error?.response?.data?.error?.error?.error?.errorList ??
    error?.response?.data?.error?.error?.errorList ??
    error?.response?.data?.error?.errorList ??
    error?.response?.data?.error ??
    error?.response?.data ??
    error?.message ??
    error;

  let finalMessage = "Unknown error occurred";

  if (Array.isArray(errorList)) {
    finalMessage = errorList[0]?.message || finalMessage;
  } else if (typeof errorList === "string") {
    finalMessage = errorList;
  } else if (errorList?.message) {
    finalMessage = errorList.message;
  } else if (typeof errorList === "object") {
    finalMessage = JSON.stringify(errorList);
  }

  console.error("Processed Error:", finalMessage);
  return finalMessage;
}
